import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Form,
  Nav,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../components/Card";
import moment from "moment";
import loader from "../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "./styles.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useAuth from "../../utils/useAuth";
import Sponsored from "./Sponsored";
import { MdOutlineDone } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ShareToFeedPopup from "./ShareToFeedPopupEvent";

const Event = () => {
  useAuth(); 
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    clearData();
  }
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const { t, i18n } = useTranslation();
  const [imagePreview, setImagePreview] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [feedData, setFeedData] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });

  // useEffect(() => {
  //   console.log("formData", formData);
  // }, [formData]);

  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") {
      const file = e.target.files[0];
      if (file) {
        if (file.size > 1 * 1024 * 1024) {
          toast.error("File size must not exceed 1MB");
          return;
        }
          setFormData({ ...formData, [name]: file });
  
        const preview = URL.createObjectURL(file);
        setImagePreview([preview]);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };

    const [eventTypeData, setEventTypeData] = useState("local");

    const handleEventTypeChange = (e) => {
      setEventTypeData(e.target.value);
    };

  const [isEditing, setIsEditing] = useState(false);
const [eventId, setEventId] = useState(null);


const handleEditClick = (eventData) => {
  setIsEditing(true);
  setEventId(eventData._id);
  setDescription(eventData?.description || '');

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  };

  setFormData({
    title: eventData?.title || '',
    image: eventData?.image || '',
    startDate: formatDateTime(eventData?.startDate),
    endDate: formatDateTime(eventData?.endDate),
    location: eventData?.location || '',
    note: eventData?.note || '',
    category: eventData?.category || '',
  });
setCategorypost(eventData?.category || '');
setEventTypeData(eventData?.eventType || '')
  setShow(true);
};

const clearData = ()=> {
  setFormData({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });
  setEventTypeData('local')

  setIsEditing(false)
setEventId(null)
  setImagePreview(null)
  setDescription("");
}
  
  const handleEvent = async () => {
    if (
      !formData.title ||
      !description ||
      !formData.location ||
      // !formData.image ||
      !formData.startDate ||
      !formData.endDate ||
      !categorypost ||
      !eventTypeData
    ) {
      toast.error("Please fill required fields");
      return;
    }

    try {
      const formDataObject = new FormData();
      formDataObject.append("title", formData.title);
      formDataObject.append("description", description);
      formDataObject.append("image", formData.image);
      formDataObject.append("startDate", formData.startDate);
      formDataObject.append("endDate", formData.endDate);
      formDataObject.append("location", formData.location);
      formDataObject.append("note", formData.note);
      formDataObject.append("category", categorypost);
      formDataObject.append("eventType", eventTypeData);

      const token = getToken();

      const url = isEditing 
      ? `${process.env.REACT_APP_URL}/api/event/${eventId}` 
      : `${process.env.REACT_APP_URL}/api/event`;
 
    const method = isEditing ? "put" : "post";

    const response = await axios({
      method,
      url,
      data: formDataObject,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    setPage(1)
    toast.success(`Event ${isEditing ? "updated" : "created"} successfully`);
      handleAllPost(true);
      clearData();
    } catch (error) {
      toast.error(error?.response?.data?.message || `Failed ${isEditing ? "updating" : "creating"} event`);
      console.log("Failed creating Event", error);
    } finally {
      setShow(false);
    }
  };
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => {
    setShowDelete(false);
    setDeleteId("");}

  const handleShowDelete = (contactid) => {
    setDeleteId(contactid);
    setShowDelete(true);
  };

  const handleDeletePost = async () => {
    if (!deleteId) {
      toast.error("Please try later");
    }
    try {
      const token = getToken();
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/api/event/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPage(1);
      handleAllPost(true);
      setDeleteId("");
      handleCloseDelete();
      // console.log("Post Deleted Successfully");
      toast.success("Post deleted successfully");
    } catch (error) {
      console.error("Failed ", error);
      toast.error(error?.response?.data?.message || "Failed to delete Contact");
    }
  };

  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

const [eventType, setEventType] = useState("");
  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      let url =  `${process.env.REACT_APP_URL}/api/event/all?page=${page}&limit=5`
      if(eventType)
      {
        url += `&searchFor=${eventType}`
      }
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (updateData) {
        setPost(response.data.data.allEvents);
      } else {
        setPost((prevPost) => [...prevPost, ...response.data.data.allEvents]);
      }
      setHasMore(response.data.data.allEvents.length > 0);
    } catch (error) {
      console.log("Failed Fetching Event", error);
    }
  };

  useEffect(() => {
    handleAllPost();
  }, [page]);

  useEffect(() => {
    handleAllPost(true);
  }, [eventType]);

  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );
      console.log(
        "Upcoming Event Fetched Successfully",
        response.data.data.allEvents
      );
      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  useEffect(() => {
    handleUpcoming();
  }, []);

  const renderDescription = (data, index) => {
    const description = data?.description;
    const threshold = 180;

    if (description && description.length > threshold) {
      if (expandedRows[index]) {
        return (
          <div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
              }}
            >
              {t('show_less')}
            </button>
          </div>
        );
      } else {
        return (
          <div>
            <div
              style={{ display: "inline" }}
              dangerouslySetInnerHTML={{
                __html: `${description.slice(0, threshold)}...`,
              }}
            />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "inline",
              }}
            >
              {t('show_more')}
            </button>
          </div>
        );
      }
    } else {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }
  };
  const [currentDate, setCurrentDate] = useState("");

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     const date = new Date();
  //     const dayOfMonth = date.getDate();
  //     setCurrentDate(dayOfMonth);
  //   }, 1000);

  //   return () => clearInterval(intervalId);
  // }, []);
  useEffect(() => {
  const date = new Date();
  setCurrentDate(date.getDate()); // set immediately

  const intervalId = setInterval(() => {
    const now = new Date();
    setCurrentDate(now.getDate());
  }, 1000);

  return () => clearInterval(intervalId);
}, []);


  const [expandedPosts, setExpandedPosts] = useState(
    Array(post.length).fill(false)
  );

  const toggleExpanded = (index) => {
    const updatedExpandedPosts = [...expandedPosts];
    updatedExpandedPosts[index] = !updatedExpandedPosts[index];
    setExpandedPosts(updatedExpandedPosts);
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportId, setReportId] = useState("");
  const handleReportClick = (reqid) => {
    setReportId(reqid);
    setReportModalOpen(true);
  };

  const closeReportModal = () => {
    setReportModalOpen(false);
  };
  const handleReport = async () => {
    if (!reportDescription) {
      toast.error("Report issue is required");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/report`,
        {
          reportFor: "event",
          issueDescription: reportDescription,
          userId: "",
          postId: "",
          eventId: reportId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeReportModal();
      setReportId("");
      setReportDescription("");
      toast.success(response.data.message);
    } catch (error) {
      setReportId("");
      setReportDescription("");
      toast.error(error?.response?.data?.message || "Failed Reporting Post");
      console.log("Failed SaviReportingng Posts", error);
    }
  };

  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const handleGoingStatus = async (eventid, status) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/event/going-status/${eventid}`,
        {
          goingStatus: status,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setPage(1)
      handleAllPost(true);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Failed Chnaging Status");
      toast.error(error?.response?.data?.message || "Failed Updating Status");
    }
  };
  const endDateRef = useRef(null);

  const navigateprofile = (id) => {
    navigate(`/userprofile/${id}`);
  };

  const handleCopyUrl = (postId) => {
    const url = `${process.env.REACT_APP_URL_POST}/event/${postId}`;
    navigator.clipboard.writeText(url).then(() => {
    //   alert('URL copied to clipboard');
    toast.success("URL Copied")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  };

  const handlePostFeed = (data) => {
    setShowPopup(true)
    setFeedData(data)
  }

  const downloadQR = async () => {
    if (!qrImageUrl?.qrCodeUrl || !qrImageUrl?.eventUID) return;
  
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // Prevent CORS issues
    image.src = qrImageUrl.qrCodeUrl;
  
    image.onload = () => {
      const padding = 70; // Extra space for UID + website + margin
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
  
      canvas.width = image.width;
      canvas.height = image.height + padding;
  
      // Set white background
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
  
      // Draw the QR image
      ctx.drawImage(image, 0, 0);
  
      // UID: Bold and 18px
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.font = "bold 18px Arial";
      ctx.fillText(qrImageUrl.eventUID, canvas.width / 2, image.height + 20);
  
      // Website: Normal and 10px
      ctx.font = "normal 10px Arial";
      ctx.fillText("www.dirido.com", canvas.width / 2, image.height + 40);
  
      // Create and trigger download
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `QR_${qrImageUrl.eventUID}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  };

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
<div >
      {/* <Container> */}
        {/* <Row> */}
          <Col lg={12} className="">
            <Tab.Container defaultActiveKey="f1">
              <Card className="">
                <div className="user-tabing">
                  {/* <Nav
                    variant="pills"
                    className="d-flex align-items-center justify-content-center profile-feed-items p-0 m-0 round"
                  >
                    <Nav.Item as="li" className="col-6 p-0">
                      <Nav.Link
                      onClick={(e)=> {setEventType("");
                        clearData(); setPage(1)}
                      }
                        className="text-center"
                        eventKey="f1"
                        href="#"
                      >
                        {t('myEvents')}
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item as="li" className="col-6 p-0">
                      <Nav.Link
                      onClick={(e)=> {setEventType("all");
                        clearData(); setPage(1)}
                      }
                        className="text-center"
                        eventKey="f2"
                        href="#"
                      >
                        {t('otherEvents')}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav> */}

                                                                             <Nav
                                              variant="pills"
                                              className="connection-tabs-nav p-0 m-0 round"
                                            >
                                              <Nav.Item as="li">
                                                <Nav.Link onClick={(e)=> {setEventType("");
                        clearData(); setPage(1)}
                      }
                                                 className="text-center"
                                                  eventKey="f1"
                                                  href="#"
                                                >
                                                    {t('myEvents')}
                                                </Nav.Link>
                                              </Nav.Item>
                                            
                                              <Nav.Item as="li">
                                                <Nav.Link onClick={(e)=> {setEventType("all");
                        clearData(); setPage(1)}
                      }
                                                  className="text-center"
                                                  eventKey="f2"
                                                  href="#"
                                                >
                                                 {t('otherEvents')}
                                                </Nav.Link>
                                              </Nav.Item>
                                            </Nav>
                </div>
              </Card>
              <Tab.Content className="forum-content">
                <Tab.Pane eventKey="f1">
                  <>
                  <Col sm={12}>
              <Card
                id="post-modal-data"
                className="card-block card-stretch card-height"
              >
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t('createEvent')}</h4>
                  </div>
                </div>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    {/* <div className="user-img">
                      <img
                        src={user1}
                        alt="user1"
                        className="avatar-60 rounded-circle"
                      />
                    </div> */}
                    <div className="user-img">
                      <img
                        className="rounded-circle img-fluid"
                        src="/calender.webp"
                        style={{ width: "85px" }}
                        alt=""
                      />
                      <div
                        style={{
                          justifyContent: "center",
                          fontSize: "24px",
                          fontWeight: "600",
                          marginTop: "-65%",
                          display: "flex",
                          color: "rgb(58,51,61)",
                        }}
                      >
                        {currentDate}
                      </div>
                    </div>
                    <form
                      className="post-text ms-3 w-100 "
                      onClick={handleShow}
                    >
                      <input
                        type="text"
                        className="form-control rounded"
                        placeholder={t('whats_on_your_mind')}
                        style={{ border: "none" }}
                      />
                    </form>
                  </div>
                
                </Card.Body>
            <ShareToFeedPopup show={showPopup} handleClose={() => setShowPopup(false)} data={feedData} />
            
                <Modal
                  size="md"
                  className="fade"
                  id="report-modal"
                  onHide={closeReportModal}
                  show={reportModalOpen}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('reportEvent')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body
                    style={{ maxHeight: "450px", overflowY: "auto" }}
                  >
                    <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t('whatAreYouReporting')}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={reportDescription}
                            onChange={(e) =>
                              setReportDescription(e.target.value)
                            }
                            className="mb-0 py-2"
                            id=""
                            placeholder={t('reportIssue')}
                            required
                          />
                        </Form.Group>
                      </li>
                    </ul>

                    <button
                      type="submit"
                      className="btn btn-primary d-block w-100 mt-3"
                      onClick={handleReport}
                    >
                      {t('report')}
                    </button>
                  </Modal.Body>
                </Modal>
              </Card>
            </Col>
            <InfiniteScroll
              dataLength={post.length}
              next={() => setPage((page) => page + 1)}
              hasMore={hasMore}
              loader={
                <div className="col-sm-12 text-center">
                  <img
                    src={loader}
                    alt="loader"
                    style={{ height: "100px" }}
                  />
                </div>
              }
              endMessage={<p className="text-center">{t("noMoreEvents")}</p>}
            >
              {post?.length === 0 ? (
  <div style={{ width: '100%', textAlign: 'center' }}>
                  <img src="/noevent.png" alt="No Event" style={{ width: '100%', height: 'auto' }} />

                  </div>
              ) : (
                // {(
                  post?.map((data, index) => (
                  <Col sm={12} key={index}>
                    <Card className=" card-block card-stretch card-height">
                      <Card.Body>
                        <div className="user-post-data">
                          <div className="d-flex justify-content-between">
                            <div className="me-3">
                              <img
                                className="rounded-circle img-fluid"
                                src="/calender.webp"
                                style={{ width: "55px" }}
                                alt=""
                              />
                              <div
                                style={{
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  marginTop: "-75%",
                                  display: "flex",
                                  color: "rgb(58,51,61)",
                                }}
                              >
                                {moment(
                                  data?.startDate ? data?.startDate : "1"
                                ).format("D")}
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h5 className="mb-0 d-inline-block">
                                    {data?.title}
                                  </h5>
                                  <p
                                    className="mb-0 text-primary"
                                    style={{ color: "black" }}
                                  >
                                    {data?.location}
                                  </p>
                                </div>
                                <div
                                  className="card-post-toolbar"
                                  style={{ display: "flex" }}
                                >
                                  {data?.qrCodeUrl ? (
                                    <div>
                                      <img
                                        src={data?.qrCodeUrl}
                                        onClick={() =>
                                          handleQrClick(data)
                                        }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                  <Dropdown>
                                    <Dropdown.Toggle variant="bg-transparent">
                                      <span className="material-symbols-outlined">
                                        more_horiz
                                      </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                     
                                          <Dropdown.Item className="p-3" to="#" onClick={() => handleCopyUrl(data?._id)}>
          <div className="d-flex align-items-top">
            <i className="ri-link h4"></i>
            <div className="data ms-2">
              <h6>{t('copy_url')}</h6>
              <p className="mb-0">{t('copy_post_url_to_clipboard')}</p>
            </div>
          </div>
        </Dropdown.Item>
        {data?.selfCreated && (

                                          <Dropdown.Item className="p-3" to="#" onClick={() => handleEditClick(data)}>
          <div className="d-flex align-items-top">
            <a style={{color:"black"}}
                          href="#"
                          className="material-symbols-outlined"
                        >
                          edit
                        </a>
            <div className="data ms-2">
              <h6>{t('edit_event')}</h6>
              <p className="mb-0">{t('update_event_details')}</p>
            </div>
          </div>
        </Dropdown.Item>)}
        {data?.selfCreated && (
                                            
                                            <Dropdown.Item className="p-3" to="#" 
                                            onClick={() => handleShowDelete(data?._id)}
                                            >
            <div className="d-flex align-items-top">
              <a style={{color:"black"}}
                            href="#"
                            className="material-symbols-outlined"
                          >
                            delete
                          </a>
              <div className="data ms-2" >
                <h6>{t('delete')} {t('post')}</h6>
                <p className="mb-0">{t('delete_the_post')}</p>
              </div>
            </div>
          </Dropdown.Item>)}
          <Dropdown.Item className="p-3" to="#" 
        onClick={() => handlePostFeed(data)}
        >
          <div className="d-flex align-items-top">
            <i className="ri-notification-line h4"></i>
            <div className="data ms-2">
              <h6>{t('shareToFeed')}</h6>
              <p className="mb-0">{t('spreadToFeed')}</p>
            </div>
          </div>
        </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "20px",
                          }}
                        >
                          <div className="containergrid_event">
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('start_date')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.startDate).format(
                                  "DD/MM/YY"
                                )}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('startTime')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.startDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('end_date')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.endDate).format("DD/MM/YY")}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('endTime')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.endDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                          </div>
                        </div>
                     
                        <div className="event-header">
  <div className="event-header-left">
    <strong
      style={{ cursor: "pointer" }}
      onClick={() => navigateprofile(data?.userId?._id)}
    >
      {data?.userId?.firstName ? data?.userId?.firstName : "N/A"}
    </strong>{" "}
    {t('createdEvent')}
  </div>

  <div className="event-header-right">
    <button
      style={{
        border: "none",
        borderRadius: "10px",
        background: "#d3d3d3",
        padding: "2px 5px",
        color: "black",
      }}
      onClick={(e) => handleGoingStatus(data?._id, "going")}
    >
      {t('going')} - {data?.goingStatusCount?.goingCount}
    </button>

    <button
      style={{
        border: "none",
        borderRadius: "10px",
        background: "#d3d3d3",
        padding: "2px 5px",
        color: "black",
      }}
      onClick={(e) => handleGoingStatus(data?._id, "maybe")}
    >
      {t('maybe')} - {data?.goingStatusCount?.maybeCount}
    </button>

    <button
      style={{
        border: "none",
        borderRadius: "10px",
        background: "#d3d3d3",
        padding: "2px 5px",
        color: "black",
      }}
      onClick={(e) => handleGoingStatus(data?._id, "not-going")}
    >
      {t('cantGo')} - {data?.goingStatusCount?.notGoingCount}
    </button>
  </div>
</div>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              color: "red",
                            }}
                          >
                            {data?.note ? (
                              <div>{t('note')}: {data?.note}</div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* {expandedPosts[index] && ( */}
                            <>
                              <div className="mt-3">
                                <p>{renderDescription(data, index)}</p>
                              </div>
                              {data?.image && (
                              <div className="user-post">
                                <img
                                  src={data?.image}
                                  alt="post1"
                                  className="img-fluid rounded w-100"
                                />
                              </div>)}
                            </>
                          {/* )} */}
                          {/* <div
                            onClick={() => toggleExpanded(index)}
                            className="text-primary"
                            style={{
                              border: "none",
                              borderRadius: "10px",
                              textAlign: "center",
                              padding: "10px 5px 0px 5px",
                            }}
                          >
                            {expandedPosts[index] ? (
                              <div>
                                Hide Details <IoIosArrowUp />
                              </div>
                            ) : (
                              <div>
                                View Details <IoIosArrowDown />
                              </div>
                            )}
                          </div> */}
                        </div>

                        {/* Other content */}
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              )}
            </InfiniteScroll>
                  </>
                </Tab.Pane>

                <Tab.Pane eventKey="f2">
                  <>
                  <Col sm={12}>
              <Card
                id="post-modal-data"
                className="card-block card-stretch card-height"
              >
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t('createEvent')}</h4>
                  </div>
                </div>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    {/* <div className="user-img">
                      <img
                        src={user1}
                        alt="user1"
                        className="avatar-60 rounded-circle"
                      />
                    </div> */}
                    <div className="user-img">
                      <img
                        className="rounded-circle img-fluid"
                        src="/calender.webp"
                        style={{ width: "85px" }}
                        alt=""
                      />
                      <div
                        style={{
                          justifyContent: "center",
                          fontSize: "24px",
                          fontWeight: "600",
                          marginTop: "-65%",
                          display: "flex",
                          color: "rgb(58,51,61)",
                        }}
                      >
                        {currentDate}
                      </div>
                      {/* <i className="ri-calendar-line"></i> */}
                    </div>
                    <form
                      className="post-text ms-3 w-100 "
                      onClick={handleShow}
                    >
                      <input
                        type="text"
                        className="form-control rounded"
                        placeholder={t('whats_on_your_mind')}
                        style={{ border: "none" }}
                      />
                    </form>
                  </div>
                 
                </Card.Body>
                <Modal centered
                  size="lg"
                  className="fade"
                  id="post-modal"
                  onHide={handleClose}
                  show={show}
                  style={{  overflow: "hidden" }}
                >
                  <Modal.Header className="d-flex justify-content-between">
                    <Modal.Title id="post-modalLabel">
                      {/* {t('createEvent')} */}
                      {isEditing ? t("edit_event") : t("createEvent")}

                    </Modal.Title>
                    <Link to="#" className="lh-1" onClick={handleClose}>
                      <span className="material-symbols-outlined">close</span>
                    </Link>
                  </Modal.Header>
                  <Modal.Body
                    style={{ maxHeight: "60lvh", overflowY: "auto" }}
                  >
                    <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                          {t('title')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="mb-0 py-2"
                            id=""
                            placeholder={t('enterTitle')}
                            required
                          />
                          <p style={{ color: "#a5a5a5" }}>
                          {t('exampleEvent')}
                          </p>
                        </Form.Group>
                      </li>
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                          {t('description')}{" "}
                            <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          {/* <CKEditor
                            editor={ClassicEditor}
                            data="<p></p>"
                            config={{
                              placeholder: t('whats_on_your_mind'),
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setDescription(data);
                            }}
                          /> */}
                          <CKEditor
  editor={ClassicEditor}
  data={description} // Use the description state here
    config={{
    toolbar: [
      'heading', '|',
      'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
      'undo', 'redo'
    ],
    removePlugins: ['ImageUpload', 'MediaEmbed', 'EasyImage'],
          placeholder: t('whats_on_your_mind'),

  }}
  onChange={(event, editor) => {
    const data = editor.getData();
    setDescription(data);
  }}
/>

                        </Form.Group>
                      </li>
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t('location')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            className="mb-0 py-2"
                            id=""
                            placeholder={t('location')}
                            required
                          />
                        </Form.Group>
                      </li>
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>{t('note')} </Form.Label>
                          <Form.Control
                            type="text"
                            name="note"
                            value={formData.note}
                            onChange={handleChange}
                            className="mb-0 py-2"
                            id=""
                            placeholder={t('note')}
                            required
                          />
                        </Form.Group>
                      </li>
                      <li className="col-12 mb-3">
                        <Form.Label>
                        {t('image')} 
                        {/* <span style={{ color: "red" }}>*</span> */}
                        </Form.Label>

                        <label
                          htmlFor="file-input"
                          style={{ cursor: "pointer", width: "100%" }}
                        >
                          <div
                            className="bg-soft-primary rounded p-1 pointer"
                            style={{
                              width: "100%",
                              textAlign: "center",
                              fontSize: "1.2rem",
                              position: "relative",
                              borderRadius: "10px",
                            }}
                          >
                            <input
                              id="file-input"
                              type="file"
                              name="image"
                              accept="image/*"
                              style={{ display: "none" }}
                              onChange={handleChange}
                            />
                            <span>
                              {formData.image ? (
                                <MdOutlineDone style={{ fontSize: "25px" }} />
                              ) : (
                                <i className="fas fa-upload"></i>
                              )}
                            </span>
                            <p style={{ marginTop: ".5rem" }}>
                              {t('click_to_select_files')}
                            </p>
                          </div>
                        </label>
                        {imagePreview?.length > 0 && (
        <div className="mt-2">
          {imagePreview?.map((preview, index) => (
            <img
              key={index}
              src={preview}
              alt={`Selected ${index}`}
              style={{
                width: "70px",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            />
          ))}
        </div>
      )}
                        {/* <MuiFileInput  onChange={handleFileInputChange} /> */}
                      </li>

                      <li className="col-12">
                        <div className="row col-12">
                          <div className="col-6 mb-3">
                            <Form.Group className="form-group">
                              <Form.Label>
                              {t('from')} <span style={{ color: "red" }}>*</span>{" "}
                              </Form.Label>
                              <Form.Control
                                value={formData.startDate}
                                onChange={handleChange}
                                type="datetime-local"
                                name="startDate"
                                className="mb-0 py-2"
                                id=""
                                placeholder={t('fromTime')}
                                required
                                min={getCurrentDateTime()}
                                onFocus={(e) => e.target.showPicker()}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-6 mb-3">
                            <Form.Group className="form-group">
                              <Form.Label>
                              {t('to')} <span style={{ color: "red" }}>*</span>{" "}
                              </Form.Label>
                              <Form.Control
                                ref={endDateRef}
                                value={formData.endDate}
                                onChange={handleChange}
                                type="datetime-local"
                                name="endDate"
                                className="mb-0 py-2"
                                id=""
                                placeholder={t('toTime')}
                                required
                                min={getCurrentDateTime()}
                                onClick={() =>
                                  endDateRef.current.showPicker &&
                                  endDateRef.current.showPicker()
                                }
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </li>

                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t("eventType")}
                            <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <div className="mb-0 ">
                            <Form.Check
                              style={{ marginRight: "20px", whiteSpace:"nowrap" }}
                              type="radio"
                              name="eventType"
                              value="local"
                              label="Local"
                              checked={eventTypeData === "local"}
                              onChange={handleEventTypeChange}
                              required
                            />
                            <Form.Check style={{whiteSpace:"nowrap"}}
                              type="radio"
                              name="eventType"
                              value="global"
                              label="Global"
                              checked={eventTypeData === "global"}
                              onChange={handleEventTypeChange}
                              required
                            />
                          </div>
                        </Form.Group>
                      </li>
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t('selectCategory')}{" "}
                            <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <div className="mb-0 ">
                            <Form.Check
                              style={{ marginRight: "20px", whiteSpace:"nowrap" }}
                              type="radio"
                              name="category"
                              value="public"
                              label={t('public')}
                              checked={categorypost === "public"}
                              onChange={handleCategoryChange}
                              required
                            />
                            <Form.Check style={{whiteSpace:"nowrap"}}
                              type="radio"
                              name="category"
                              value="private"
                              label={t('private')}
                              checked={categorypost === "private"}
                              onChange={handleCategoryChange}
                              required
                            />
                          </div>
                        </Form.Group>
                      </li>
                    </ul>

                    <button
                      type="submit"
                      className="btn btn-primary d-block w-100 mt-3"
                      onClick={handleEvent}
                    >
                      {t('post')}
                    </button>
                  </Modal.Body>
                </Modal>
                <Modal
                  size="sm"
                  className="fade"
                  id="qr-modal"
                  onHide={closeQrPopup}
                  show={qrPopupOpen}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('qr_code')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="text-center">
                  <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
          <img
            src={qrImageUrl?.qrCodeUrl}
            alt="QR Code"
            style={{ maxWidth: "300px", height: "auto" }}
          />
          <span style={{fontSize:"18px", fontWeight:"600"}}>{qrImageUrl?.eventUID}</span>
          <span style={{fontSize:"10px", fontWeight:"300"}}>www.dirido.com</span>
          </div>
          <button className="btn btn-primary mt-3" onClick={downloadQR}>
        {t("download_qr_code")}
      </button>
                  </Modal.Body>
                  {/* <Modal.Footer>
                    <button
                      className="btn btn-secondary"
                      onClick={closeQrPopup}
                    >
                      {t('close')}
                    </button>
                  </Modal.Footer> */}
                </Modal>
                <Modal
                  size="md"
                  className="fade"
                  id="report-modal"
                  onHide={closeReportModal}
                  show={reportModalOpen}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('reportEvent')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body
                    style={{ maxHeight: "450px", overflowY: "auto" }}
                  >
                    <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                      <li className="col-12 ">
                        <Form.Group className="form-group">
                          <Form.Label>
                            {t('whatAreYouReporting')}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={reportDescription}
                            onChange={(e) =>
                              setReportDescription(e.target.value)
                            }
                            className="mb-0 py-2"
                            id=""
                            placeholder={t('reportIssue')}
                            required
                          />
                        </Form.Group>
                      </li>
                    </ul>

                    <button
                      type="submit"
                      className="btn btn-primary d-block w-100 mt-3"
                      onClick={handleReport}
                    >
                      {t('Report')}
                    </button>
                  </Modal.Body>
                </Modal>
              </Card>
            </Col>
            <InfiniteScroll
              dataLength={post.length}
              next={() => setPage((page) => page + 1)}
              hasMore={hasMore}
              loader={
                <div className="col-sm-12 text-center">
                  <img
                    src={loader}
                    alt="loader"
                    style={{ height: "100px" }}
                  />
                </div>
              }
              // endMessage={<p className="text-center">No more events</p>}
            >
              {post?.length === 0 ? (
                  <div style={{ width: '100%', textAlign: 'center' }}>
                  {/* No Events Yet */}
                                  <img src="/noevent.png" alt="No Event" style={{ width: '100%', height: 'auto' }} />
              
                                  </div>
              ) : (
                post?.map((data, index) => (
                  <Col sm={12} key={index}>
                    <Card className=" card-block card-stretch card-height">
                      <Card.Body>
                        <div className="user-post-data">
                          <div className="d-flex justify-content-between">
                            <div className="me-3">
                              <img
                                className="rounded-circle img-fluid"
                                src="/calender.webp"
                                style={{ width: "55px" }}
                                alt=""
                              />
                              <div
                                style={{
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  marginTop: "-75%",
                                  display: "flex",
                                  color: "rgb(58,51,61)",
                                }}
                              >
                                {moment(
                                  data?.startDate ? data?.startDate : "1"
                                ).format("D")}
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h5 className="mb-0 d-inline-block">
                                    {data?.title}
                                  </h5>
                                  <p
                                    className="mb-0 text-primary"
                                    style={{ color: "black" }}
                                  >
                                    {data?.location}
                                  </p>
                                </div>
                                <div
                                  className="card-post-toolbar"
                                  style={{ display: "flex" }}
                                >
                                  {data?.qrCodeUrl ? (
                                    <div>
                                      <img
                                        src={data?.qrCodeUrl}
                                        onClick={() =>
                                          handleQrClick(data)
                                        }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                  <Dropdown>
                                    <Dropdown.Toggle variant="bg-transparent">
                                      <span className="material-symbols-outlined">
                                        more_horiz
                                      </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                      <Dropdown.Item
                                        className="p-3"
                                        onClick={() =>
                                          handleReportClick(data._id)
                                        }
                                      >
                                        <div className="d-flex align-items-top">
                                          <div className="h4 material-symbols-outlined">
                                            <i className="ri-close-circle-line h4"></i>
                                          </div>{" "}
                                          <div className="data ms-2">
                                            <h6>{t('reportEvent')}</h6>
                                            <p className="mb-0">
                                              {t('reportInappropriateContent')}
                                            </p>
                                          </div>
                                        </div>
                                      </Dropdown.Item>
                                      <Dropdown.Item className="p-3" to="#" onClick={() => handleCopyUrl(data?._id)}>
          <div className="d-flex align-items-top">
            <i className="ri-link h4"></i>
            <div className="data ms-2">
              <h6>{t('copy_url')}</h6>
              <p className="mb-0">{t('copy_post_url_to_clipboard')}</p>
            </div>
          </div>
        </Dropdown.Item>
        {data?.selfCreated && (
        <Dropdown.Item className="p-3" to="#" onClick={() => handleEditClick(data)}>
          <div className="d-flex align-items-top">
            <a style={{color:"black"}}
                          href="#"
                          className="material-symbols-outlined"
                        >
                          edit
                        </a>
            <div className="data ms-2">
              <h6>{t('edit_event')}</h6>
              <p className="mb-0">{t('update_event_details')}</p>
            </div>
          </div>
        </Dropdown.Item>)}
        <Dropdown.Item className="p-3" to="#" 
        onClick={() => handlePostFeed(data)}
        >
          <div className="d-flex align-items-top">
            <i className="ri-notification-line h4"></i>
            <div className="data ms-2">
              <h6>{t('shareToFeed')}</h6>
              <p className="mb-0">{t('spreadToFeed')}</p>
            </div>
          </div>
        </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "20px",
                          }}
                        >
                          <div className="containergrid_event">
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('start_date')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.startDate).format(
                                  "DD/MM/YY"
                                )}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('startTime')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.startDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('end_date')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.endDate).format("DD/MM/YY")}
                              </div>
                            </div>
                            <div className="boxgrid_event">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('endTime')}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                {moment(data?.endDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#ececec",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "20px",
                          }}
                        >
                          <div style={{ flex: "1", marginRight: "10px" }}>
                            <strong
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigateprofile(data?.userId?._id)
                              }
                            >
                              {data?.userId?.firstName
                                ? data?.userId?.firstName
                                : "John"}
                            </strong>{" "}
                            {t('createdEvent')}
                          </div>
                          <div>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "going")
                              }
                            >
                              {t('going')} - {data?.goingStatusCount?.goingCount}
                            </button>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "maybe")
                              }
                            >
                              {t('maybe')} - {data?.goingStatusCount?.maybeCount}
                            </button>
                            <button
                              style={{
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "not-going")
                              }
                            >
                              {t('cantGo')} -{" "}
                              {data?.goingStatusCount?.notGoingCount}
                            </button>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              color: "red",
                            }}
                          >
                            {data?.note ? (
                              <div>{t('note')}: {data?.note}</div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* {expandedPosts[index] && ( */}
                            <>
                              <div className="mt-3">
                                <p>{renderDescription(data, index)}</p>
                              </div>
                              {data?.image && (
                              <div className="user-post">
                                <img
                                  src={data?.image}
                                  alt="post1"
                                  className="img-fluid rounded w-100"
                                />
                              </div>)}
                            </>
                          {/* )} */}
                          {/* <div
                            onClick={() => toggleExpanded(index)}
                            className="text-primary"
                            style={{
                              border: "none",
                              borderRadius: "10px",
                              textAlign: "center",
                              padding: "10px 5px 0px 5px",
                            }}
                          >
                            {expandedPosts[index] ? (
                              <div>
                                Hide Details <IoIosArrowUp />
                              </div>
                            ) : (
                              <div>
                                View Details <IoIosArrowDown />
                              </div>
                            )}
                          </div> */}
                        </div>

                        {/* Other content */}
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              )}
            </InfiniteScroll>
                  </>
                </Tab.Pane>
                
              </Tab.Content>
            </Tab.Container>
            
          </Col>

         
        
        {/* </Row> */}
      {/* </Container> */}
      <Modal
                                                        size="md"
                                                        className="fade"
                                                        id="post-modal"
                                                        onHide={handleCloseDelete}
                                                        show={showDelete}
                                                        centered
                                                        style={{ marginTop: "100px", maxHeight: "80vh" }}
                                                      >
                                                        <Modal.Header className="d-flex justify-content-between">
                                                          <Modal.Title id="post-modalLabel">{t('delete_post')}</Modal.Title>
                                                          <Link to="#" className="lh-1" onClick={handleCloseDelete}>
                                                            <span className="material-symbols-outlined">close</span>
                                                          </Link>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                          <div
                                                            className="d-flex align-items-center"
                                                            style={{ fontSize: "16px" }}
                                                          >
                                                            <p>
                                                              {t('delete_confirm_event')}
                                                            </p>
                                                          </div>
                                                          <button
                                                            type="submit"
                                                            className="btn btn-primary d-block w-100 mt-0"
                                                            onClick={handleDeletePost}
                                                          >
                                                            {t('delete')}       </button>
                                                        </Modal.Body>
                                                      </Modal>
    </div>
  </>
  );
};

export default Event;
